import axios from "axios";

import { instance } from ".";
import store from "../../store";
import { setToken } from "../../slice/loginSlice";

const url = process.env.REACT_APP_BASE_URL || "/";

const OnRequest = async (config) => {
  if(localStorage.getItem("isError")){
    localStorage.removeItem("isError")
  }
 const token =localStorage.getItem("admin_token")||{}
  if (token && config.headers) {
    config.headers.Authorization = "Bearer " + token;
  }

  return config;
};

const onRequestError = (error) => {
  return Promise.reject(error);
};

const onResponse = (response) => {
  return response;
};

const onResponseError = async (error) => {
  const originalConfig = error.config;
  if (error.response?.status === 401) {
    const rootState = store.getState();
    const refresh = rootState?.Loginreducer?.loginData?.refresh_token || {};
    const { status } = error.response;
    if (status === 401 && !originalConfig._retry) {
      // store. dispatch(logoutRequest({}));
      originalConfig._retry = true;

      try {
        const request = {
          refresh_token: refresh,
        };
        const URL = url + "/refresh-token";
        let responseData = await axios.post(URL, request, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (responseData?.data?.access_token) {
          const { access_token } = responseData?.data;
          originalConfig.headers.Authorization = access_token;
          store.dispatch(setToken(responseData?.data));
          localStorage.setItem("admin_token",responseData?.data?.access_token)
          return instance(originalConfig);
        }

        localStorage.clear();
        window.location.replace("/login");
      } catch (err) {
        localStorage.clear();
        window.location.replace("/login");
      }
    }
  } else {
    return Promise.reject(error);
  }
};

export function setupInterceptorsTo(axiosInstance) {
  axiosInstance.interceptors.request.use(OnRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
